import type { PlayerColorKey } from '@clicklinx/protocol'

/**
 * Seat colours are fixed and never reassigned mid-match, so a player learns
 * "I am the lime one" once and can then read the scoreboard without reading
 * any names. The four hues are far apart in hue *and* lightness so they stay
 * separable for the most common colour-vision deficiencies.
 */
export const SEAT_COLORS: Record<PlayerColorKey, string> = {
  lime: '#d7ff3e',
  cyan: '#42e2f5',
  magenta: '#ff52c8',
  orange: '#ff8a3d',
}

/** A dim wash of the seat colour, for backgrounds behind text. */
export function seatWash(color: PlayerColorKey, alpha = 0.14): string {
  const hex = SEAT_COLORS[color]
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

/** Two initials, for the compact seat marker. */
export function initialsOf(displayName: string): string {
  const parts = displayName.trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return '??'
  if (parts.length === 1) return (parts[0] as string).slice(0, 2).toUpperCase()
  return ((parts[0]?.[0] ?? '') + (parts[1]?.[0] ?? '')).toUpperCase()
}
